import { adminRoles } from '@/constants';
import { checkAndRedirectForOrgAdminAccess } from '@/helpers';
import { apiClient } from '@/lib/api-client';
import { useAppStore } from '@/stores/app';
import { SAMLMetadata } from '@/types';
import type { SAMLProviderGetResponse } from '@/types';
import { createFileRoute, redirect } from '@tanstack/react-router';

export type SAMLProviderFormDefaults = {
  provider_name: string;
  email_domain: string;
  metadata_url?: string | null;
  metadata_file?: string | null;
  attr_email: string;
  attr_first_name: string;
  attr_last_name: string;
  attr_roles: string;
};

export const Route = createFileRoute('/auth/')({
  beforeLoad: ({ context, location }) => {
    const selectedOrganization = useAppStore.getState()?.selectedOrganization;
    checkAndRedirectForOrgAdminAccess({
      context,
      location,
      selectedOrganization,
      adminRoles,
      redirect,
    });
  },
  loader: async () => {
    try {
      const [metadata, provider] = await Promise.all([
        apiClient.get<SAMLMetadata>('/auth/saml/metadata'),
        apiClient.get<SAMLProviderGetResponse>('/auth/saml/provider'),
      ]);

      let providerDefaults: SAMLProviderFormDefaults = {
        provider_name: '',
        email_domain: '',
        metadata_url: '',
        metadata_file: '',
        attr_email: '',
        attr_first_name: '',
        attr_last_name: '',
        attr_roles: '',
      };
      if (provider) {
        providerDefaults = {
          provider_name: provider.provider_name ?? '',
          email_domain: provider.email_domain ?? '',
          metadata_url: provider.metadata_url ?? '',
          metadata_file: provider.metadata_file ?? '',
          attr_email: provider.attribute_mapping?.email ?? '',
          attr_first_name: provider.attribute_mapping?.first_name ?? '',
          attr_last_name: provider.attribute_mapping?.last_name ?? '',
          attr_roles: provider.attribute_mapping?.roles ?? '',
        };
      }

      return {
        samlMetadata: {
          recipient: metadata?.recipient ?? '',
          audience: metadata?.audience ?? '',
        },
        providerDefaults,
      };
    } catch {
      return {
        samlMetadata: { recipient: '', audience: '' },
        providerDefaults: {},
      };
    }
  },
  // No component here! The component is loaded via index.lazy.tsx
});
